export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'non-binary', label: 'Non-Binary' },
  { value: 'genderqueer', label: 'Genderqueer' },
  { value: 'genderfluid', label: 'Genderfluid' },
  { value: 'agender', label: 'Agender' },
  { value: 'two-spirit', label: 'Two-spirit' },
  { value: 'androgynous', label: 'Androgynous' },
  { value: 'bi-gender', label: 'Bi-gender' },
  { value: 'demigender', label: 'Demigender' },
  { value: 'nutrois', label: 'Nutrois' },
  { value: 'gender-nonconforming', label: 'Gender Nonconforming' },
  { value: 'transgender', label: 'Transgender' },
  { value: 'trans-woman', label: 'Trans Woman' },
  { value: 'trans-man', label: 'Trans Man' },
  { value: 'other', label: 'Other' }
]
